import { render } from "./ModalComposition.vue?vue&type=template&id=0a87e5dc"
import script from "./ModalComposition.vue?vue&type=script&lang=js"
export * from "./ModalComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__